import React from "react";
import { Link } from "react-router-dom";
import facebook from "../../assets/img/social/facebook.png";
import whatsapp from "../../assets/img/social/whatsapp.png";
import linkedin from "../../assets/img/social/linkedin.png";
const socialMediaUrl = [
  {
    id: "1",
    imgUrl: linkedin,
    socialLink: "https://www.linkedin.com/",
  },
  {
    id: "2",
    imgUrl: facebook,
    socialLink: "https://www.facebook.com/",
  },
  {
    id: "3",
    imgUrl: whatsapp,
    socialLink:
      "https://wa.me/+966565722871",
  }
];
function SocialMedia() {
  return (
    <div className="socialIconBox">      
      {socialMediaUrl.map((item, key) => {
        return (
          <div className="socialIcon" key={item.id}>
            <a href={item?.socialLink} target="_blank">
              <img src={item.imgUrl} alt="socialLink" width={30} />
            </a>
          </div>
        );
      })}
    </div>
  );
}

export default SocialMedia;
